import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"

import { WallGraphic } from "@/components/wall/WallGraphic"
import { db } from "@/database/database"
import { IntroContent } from "@/sections/layouts/IntroContent"

export const Route = createFileRoute("/$sessionId/_session/intro/wallDetail")({
  component: IntroLocationRoute,
})

function IntroLocationRoute() {
  const { sessionId } = Route.useParams()

  const navigate = useNavigate()

  const onContinueClick = useCallback(async () => {
    const nextStep = await db.orderedStep.finishAndGetNext({
      sessionId,
      step: "Intro",
    })

    if (nextStep) {
      navigate({ to: nextStep.to, params: { ...nextStep.params }, replace: true })
    }
  }, [navigate, sessionId])

  return (
    <IntroContent
      aboveHeading={<WallGraphic type="HouseDetail" />}
      activeStepIndex={4}
      numberOfSteps={5}
      onLinkClick={onContinueClick}
      heading={{ i18nKey: "intro.wallDetail.heading" }}
      subheading={{
        i18nKey: "general.howTo",
      }}
      description={{
        i18nKey: "intro.wallDetail.description",
        components: {
          uppercase: <span className="uppercase" />,
          bold: <span className="text-ic-primary font-bold" />,
        },
      }}
    />
  )
}
